import { DateValue } from "@ark-ui/react";

export default function isDefaultMonth(
  monthValue: number,
  defaultValue?: DateValue[],
): boolean {
  if (!defaultValue?.length) return false;
  return defaultValue.some((date) => date.month === monthValue);
}
